import { Button, CertificationBadge } from '@common/components';
import { SvgInfo } from '@common/icon';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import Logo from '@/assets/svgs/logo.svg';
import { ROUTES } from '@/constants';

import { BusinessInfo } from './_components/BusinessInfo';
import { DonationInfo } from './_components/DonationInfo';
import { PolicyInfo } from './_components/PolicyInfo';

interface FooterProps {
  className?: string;
}

export const FooterPc = ({ className }: FooterProps) => {
  return (
    <footer
      className={cn(
        'flex w-full min-w-[75rem] justify-center bg-Gray-50 px-40',
        className,
      )}
    >
      <section className="flex w-[75rem] flex-col py-40">
        <div className="flex justify-between gap-96 pb-60">
          <div className="h-29 w-86 [&_path]:fill-Gray-400">
            <Logo style={{ width: '100%', height: '100%' }} />
          </div>

          <BusinessInfo />

          <DonationInfo />

          <PolicyInfo />
        </div>

        <div className="flex items-center justify-between gap-16">
          <CertificationBadge
            className="items-start gap-22"
            size={40}
            isHideCSAP
          />
          <p className="flex items-center gap-4 font-400 text-Gray-600 typo-caption2">
            <SvgInfo className="size-12" />
            일부 콘텐츠는 AI를 활용하여 제작되었습니다.
          </p>
        </div>

        <div className="my-24 flex flex-col gap-8 border-t-[0.5px] border-Gray-500 py-16 ">
          <p className="font-400 text-Gray-600 typo-caption2">
            (주)웰로에서 제공하는 정보는 신뢰할 만한 자료 및 정보로부터 얻어진
            것이나 그 정확성이나 완전성을 보장할 수 없으며, 시간이 경과함에 따라
            변경될 수 있습니다. 따라서 정보의 오류, 누락에 대하여 (주)웰로 또는
            (주)웰로에 자료를 제공하는 기관에서는 그 결과에 대해 법적인 책임을
            지지 않습니다. (주)웰로가 소유/운영/관리하는 웹사이트 및 앱의 이벤트
            정보 및 모든 정보 UI, 콘텐츠 등에 대한 무단 복제, 배포, 발송 또는
            전송, 스크래핑 등의 행위는 관련 법령에 의하여 엄격히 금지 됩니다.
          </p>
          <Button
            asChild
            className="w-fit rounded-xxsmall bg-Gray-white font-600 typo-caption2"
            dimensions="H26"
            theme="sub-line"
          >
            <CustomLink href={ROUTES.CONTENT_COMPLIANCE_INFORMATION.pathname}>
              콘텐츠산업 진흥법에 따른 표시
            </CustomLink>
          </Button>
        </div>
      </section>
    </footer>
  );
};
